"use client";
import { Heading } from "@ecco/ui/heading";
import { Box } from "@ecco/ui/box";
import { Text } from "@ecco/ui/text";
import { StoreFinder } from "@features/stores/components/StoreFinder";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ClickAndCollect, CommonCMS } from "@lib/constants/contentful";

export default function StoreLocatorClient() {
    const { getMultiple } = useMicrocopy();
    const microcopies = getMultiple(CommonCMS.page, [
        ClickAndCollect.storeLocatorHeadline,
        ClickAndCollect.storeLocatorDescription,
    ]);

    return (
        <div data-testid="StoreLocatorPage">
            <Box
                mx={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}
                gap={4}
                pb={[6, 12]}
                mt={[5, 8]}
            >
                <Heading as="h1" mb={4}>
                    {microcopies[ClickAndCollect.storeLocatorHeadline]}
                </Heading>
                <Text>{microcopies[ClickAndCollect.storeLocatorDescription]}</Text>
            </Box>
            <Box m={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}>
                <StoreFinder />
            </Box>
        </div>
    );
}
